import {
  FETCH_CASHOUTS_REQUEST,
  FETCH_CASHOUTS_SUCCESS,
  FETCH_CASHOUTS_FAILURE,
  UPDATE_CASHOUT_REQUEST,
  UPDATE_CASHOUT_SUCCESS,
  UPDATE_CASHOUT_FAILURE,
} from "./types";

import {
  fetchCashouts,
  updateCashoutStatus,
} from "../../services/cashoutService";


export const fetchCashoutsAction = (page = 1, size = 10) => async (dispatch) => {
  dispatch({ type: FETCH_CASHOUTS_REQUEST });

  try {
    const response = await fetchCashouts(page, size);

    if (response.success) {
      dispatch({
        type: FETCH_CASHOUTS_SUCCESS,
        payload: response.data,
      });
    } else {
      dispatch({
        type: FETCH_CASHOUTS_FAILURE,
        payload: response.error,
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_CASHOUTS_FAILURE,
      payload: error.message,
    });
  }
};



export const updateCashoutAction = (id, payload) => async (dispatch) => {
  dispatch({ type: UPDATE_CASHOUT_REQUEST });

  try {
    const apiPayload = {
      status: payload.status,
      status_reason: payload.status_reason, 
    };

    const response = await updateCashoutStatus(id, apiPayload);

    if (response.success) {
      dispatch({
        type: UPDATE_CASHOUT_SUCCESS,
        payload: {
          id,
          status: payload.status,
          status_reason: payload.status_reason,
        },
      });
    } else {
      dispatch({
        type: UPDATE_CASHOUT_FAILURE,
        payload: response.error,
      });
    }
  } catch (error) {
    dispatch({
      type: UPDATE_CASHOUT_FAILURE,
      payload: error.message,
    });
  }
};